import React from 'react'
import { StyleSheet } from 'react-native'
import { Layout, Spinner } from '@ui-kitten/components'
import { useBundleGate } from '../hooks/useBundleGate'
import BundleUpdateScreen from './BundleUpdateScreen'

/**
 * ATL-1452 — wraps everything below the auth spinner in Routes (signed-in AND signed-out). Until the
 * launch is decided the app is held behind a neutral spinner; while locked, the update screen shows.
 *
 * While either shows, the app is NOT MOUNTED — nothing of it exists to navigate (the Android back
 * button), to type or scan into (a web document keydown listener), or to open a modal above a cover.
 * A lock is only taken at the launch, so the app has never been mounted before it: a release mounts it
 * for the first time, exactly like an unlocked launch. Queued dual-writes are not lost meanwhile — the
 * outbox is persistent and drains once the app (and its organization) loads, here or after the restart.
 */
export default function BundleGate({ children }: { children: React.ReactNode }) {
  const gate = useBundleGate()

  if (!gate.launchDecided) {
    return (
      <Layout style={styles.center}>
        <Spinner size="large" />
      </Layout>
    )
  }
  if (gate.locked) {
    return (
      <BundleUpdateScreen message={gate.message} bundleFloor={gate.floor} onAttemptEnded={gate.release} />
    )
  }
  return <>{children}</>
}

const styles = StyleSheet.create({
  center: { flex: 1, justifyContent: 'center', alignItems: 'center' },
})
